module.exports = __webpack_public_path__ + "img/el-kios-04.4311cfa9.jpg";